import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Auth from './components/Auth';
import PanelAdmin from './components/PanelAdmin';
import ClubConfig from './components/ClubConfig';
import AdminDashboard from './components/AdminDashboard';
import Events from './components/Events';
import AdminEvents from './components/AdminEvents';
import AdminEventConfig from './components/AdminEventConfig';
import UserList from './components/UserList';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<App />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/admin-panel" element={<PanelAdmin />}>
          <Route index element={<AdminDashboard />} />
          <Route path="club/:id" element={<ClubConfig />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="events/new" element={<AdminEventConfig />} />
          <Route path="events/:id/edit" element={<AdminEventConfig />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
